import { limpaSessao, renovaToken, precisaRenovar, segundosAteExpirar, getRefreshToken } from '../auth'

export const tokenInfo = {
  created () {
    if (!window.localStorage.getItem('tokenLaravel')) {
      return
    }

    // Token perto do fim (ou já vencido) na carga da página: tenta renovar antes
    // de deslogar. Só cai no login se não houver refresh token ou ele for recusado.
    if (!precisaRenovar() && segundosAteExpirar() > 0) {
      return
    }

    if (!getRefreshToken()) {
      this.encerraSessao()

      return
    }

    renovaToken().catch(() => {
      this.encerraSessao()
    })
  },
  methods: {
    encerraSessao: function () {
      this.$store.commit('REMOVE_USER')
      this.$store.commit('REMOVE_USER_DETAIL')
      this.$store.commit('REMOVE_USER_LARAVEL')
      limpaSessao()
      this.$router.push('/login')
    },
    verificaToken: function () {
      if (window.localStorage.getItem('token')) {
        let token = window.localStorage.getItem('token')
        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace('-', '+').replace('_', '/')
        // pega a data que o token vai expirar
        let tokenExpiraEm = JSON.parse(window.atob(base64)).exp
        // pega a data atual do sistema
        let currentTime = new Date().getTime() / 1000

        // verifica se o token já expirou
        if (currentTime > tokenExpiraEm) {
          this.encerraSessao()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tokenInfo.js